import type { AccessibleSVGProps } from '@core/svg'
import { AccessibleSVG } from '@core/svg'

/**
 * Exclamation mark icon.
 */
export const ExclamationMark: React.FC<AccessibleSVGProps> = (props) => (
  <AccessibleSVG width={17} height={16} fill="none" {...props}>
    <rect width={16} height={16} x={0.492} fill={props.fill || '#FA0'} rx={8} />
    <path
      fill="#fff"
      d="M7.645 8.63V3.92h1.68v4.71h-1.68Zm1.82 1.52c0 .133-.026.26-.08.38a.846.846 0 0 1-.21.3.97.97 0 0 1-.31.19.926.926 0 0 1-.38.08c-.133 0-.26-.023-.38-.07a.91.91 0 0 1-.3-.2 1.058 1.058 0 0 1-.21-.3.936.936 0 0 1 .2-1.04.887.887 0 0 1 .31-.2.925.925 0 0 1 .38-.08c.134 0 .26.027.38.08.12.047.224.113.31.2.094.08.164.18.21.3.054.113.08.233.08.36Z"
    />
  </AccessibleSVG>
)
